import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import
{
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";

//import images
import avatar1 from "../../assets/images/users/user-dummy-img.jpg";
import axiosInstance from "../../axiosConfig";
import { lireRoleSession } from "../../espace";

const ProfileDropdown = ( props ) =>
{
  const { user } = useSelector( ( state ) => ( {
    user: state.Profile.user,
  } ) );

  const [ Solde, setSolde ] = useState( "" );
  const [ userFirstName, setUserFirstName ] = useState( "" );
  const [ userLastName, setUserLastName ] = useState( "" );
  const [ roleSession, setRoleSession ] = useState( lireRoleSession )

  useEffect( () =>
  {
    if ( localStorage.getItem( "authUser" ) )
    {
      const obj = JSON.parse( localStorage.getItem( "authUser" ) );
      setUserFirstName( user.first_name || obj.data.first_name || "Prénom" );
      setUserLastName( user.last_name || obj.data.last_name || "Nom" );
      setRoleSession( obj.role || "" )
    }
  }, [ userFirstName, userLastName, user ] );


  //Dropdown Toggle
  const [ isProfileDropdown, setIsProfileDropdown ] = useState( false );
  const toggleProfileDropdown = () =>
  {
    setIsProfileDropdown( !isProfileDropdown );
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={ isProfileDropdown }
        toggle={ toggleProfileDropdown }
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <img
              className="rounded-circle header-profile-user"
              src={ avatar1 }
              alt="Header Avatar"
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                { userFirstName }
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                { userLastName }
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <h6 className="dropdown-header">
            { props.t( "Welcome" ) } { userFirstName }!
          </h6>
          <DropdownItem href="/profile">
            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">{ props.t( "Profile" ) }</span>
          </DropdownItem>
          <DropdownItem href="/alertes">
            {/* <span className="badge bg-soft-success text-success mt-1 float-end">
              En Cours
            </span> */}
            <i className="bx bx-bell text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Alertes</span>
          </DropdownItem>

          <DropdownItem href="/facturation">
            <i className="bx bx-list-ul text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Facturation</span>
          </DropdownItem>
          {/* 
          <DropdownItem href="/apps-tasks-kanban">
            <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Taskboard</span>
          </DropdownItem>

          <DropdownItem href="/pages-faqs">
            <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">{props.t("Help")}</span>
          </DropdownItem> */}
          <div className="dropdown-divider"></div>
          {/* <DropdownItem href="/profile">
            <span className="badge bg-soft-success text-success mt-1 float-end">
              {props.t("New")}
            </span>
            <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">{props.t("Settings")}</span>
          </DropdownItem> */}
          {/* <DropdownItem href="/auth-lockscreen-basic">
            <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">{props.t("Lock screen")}</span>
          </DropdownItem> */}
          <DropdownItem href={ roleSession === "ORGANISATEUR" ? "/logout-organizer" : "/logout" }>
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{ " " }
            <span className="align-middle" data-key="t-logout">
              { props.t( "Logout" ) }
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileDropdown.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter( withTranslation()( ProfileDropdown ) );
